import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BiSolidUserX } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

import { useDeleteUserMutation } from "../../app/services/auth-rtk.service";
import { MultiLanguageUrl } from "../../constants/multiLanguage.constant";

export default function DeleteAccount() {
  const { t, i18n } = useTranslation();
  const navigation = useNavigate();

  const [userDeleteRequest, userDeleteRequestResults] = useDeleteUserMutation();

  const [showMenu, setShowMenu] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const closeMenu = () => {
    setShowMenu(false);
  };

  const onDeleteAccount = () => {
    userDeleteRequest()
      .unwrap()
      .then(() => {
        navigation(`/${MultiLanguageUrl[i18n.language] || "en-US"}/logout`);
      });
  };

  return (
    <React.Fragment>
      <div className="tw-h-[174px] tw-px-6 tw-mt-6 tw-pb-8 tw-bg-[#f8f9fa] tw-rounded-lg tw-shadow tw-flex-col tw-justify-center tw-items-center tw-gap-6 ">
        <div className="tw-h-14 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-flex">
          <div className="tw-self-stretch tw-text-gray-700 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">
            {t("DeletAccount/title")}
          </div>
          <div className="tw-self-stretch ">
            <span className="tw-text-gray-700 tw-text-sm tw-font-semibold tw-font-['Lexend'] tw-leading-tight">
              {t("DeletAccount/sub-description")}
            </span>
            <span className="tw-text-gray-700 xl:tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
              {t("DeletAccount/description")}
            </span>
          </div>
        </div>
        <div className=" tw-mt-[50px] tw-px-[21px] tw-py-[7px] tw-bg-[#e34a51] tw-rounded-[21px] tw-shadow tw-justify-center tw-items-center tw-inline-flex">
          <div
            className="tw-cursor-pointer tw-text-white tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal"
            onClick={() => {
              setShowMenu((prev) => !prev);
            }}
            role="button"
            onKeyDown={() => setShowMenu((prev) => !prev)}
            tabIndex={-1}
          >
            {t("DeletAccount/btn")}
          </div>
        </div>
      </div>
      <Modal
        centered
        show={showMenu}
        onHide={closeMenu}
        dialogClassName="tw-max-w-[366px]"
      >
        <Modal.Body className="tw-py-5 tw-px-6">
          <div className="tw-flex tw-flex-col tw-w-full tw-items-center tw-justify-center tw-gap-y-3">
            <div className="tw-w-10 tw-h-10 tw-p-2.5 tw-bg-red-100 tw-rounded-3xl tw-justify-center tw-items-center tw-inline-flex">
              <div className="tw-grow tw-shrink tw-basis-0 tw-self-stretch tw-pl-[1.67px] tw-pr-[1.91px] tw-pt-[4.21px] tw-pb-[4.17px] tw-justify-center tw-items-center tw-inline-flex">
                <BiSolidUserX size={22} className="tw-text-red-500" />
              </div>
            </div>
            <div className="tw-self-stretch tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-flex tw-my-[10px]">
              <div className="tw-self-stretch tw-text-center tw-text-gray-700 tw-text-xl tw-font-semibold tw-font-['Lexend'] tw-leading-7">
                {t("DeletAccount/modal-title")}
              </div>
              <div className="tw-self-stretch tw-text-center tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend']">
                {t("DeletAccount/modal-description")}
              </div>
            </div>
            <div className="tw-flex tw-flex-col tw-w-full tw-gap-y-4 tw-my-4">
              <Form.Group>
                <Form.Control
                  className="tw-font-['Lexend']"
                  name="assure"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </Form.Group>
              <Button
                disabled={
                  inputValue !== "CONFIRM" || userDeleteRequestResults.isLoading
                }
                onClick={onDeleteAccount}
                className="tw-w-full tw-cursor-pointer tw-text-white tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight tw-grow tw-shrink tw-basis-0 tw-h-[38px] tw-px-[17px] tw-py-[9px] tw-bg-red-600 hover:tw-bg-red-700 disabled:tw-bg-red-700 tw-rounded-[99px] tw-justify-center tw-items-center tw-flex"
              >
                {userDeleteRequestResults.isLoading ? (
                  <Spinner size="sm" />
                ) : (
                  t("DeletAccount/btn-02")
                )}
              </Button>
              <Button
                onClick={closeMenu}
                className="tw-grow tw-shrink tw-basis-0 tw-h-[42px] tw-px-[17px] tw-py-[9px] tw-bg-white hover:tw-bg-white hover:tw-text-gray-800 tw-border tw-border-solid tw-border-gray-300 hover:tw-border-gray-300  tw-rounded-[99px] tw-justify-center tw-items-center tw-flex tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight"
              >
                {t("DeletAccount/btn-01")}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
